import { render, staticRenderFns } from "./LoginAgent.vue?vue&type=template&id=22fff8ad&scoped=true"
import script from "./LoginAgent.vue?vue&type=script&lang=js"
export * from "./LoginAgent.vue?vue&type=script&lang=js"
import style0 from "./LoginAgent.vue?vue&type=style&index=0&id=22fff8ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fff8ad",
  null
  
)

export default component.exports